var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteOptimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.103 11.814-2.434.004c-.327 0-.635-.127-.865-.358a1.213 1.213 0 0 1-.359-.864V9.93c0-.674.548-1.222 1.223-1.222h4.094c1.22 0 2.217-.993 2.223-2.214l.003-.674a2.203 2.203 0 0 0-.65-1.578 2.207 2.207 0 0 0-1.574-.653h-.005l-1.666.01a.5.5 0 0 0 .004 1H8.1l1.663-.01h.003c.327 0 .634.127.865.359.232.232.358.54.357.868l-.003.674A1.226 1.226 0 0 1 9.762 7.71H5.668a2.225 2.225 0 0 0-2.223 2.222v.665c0 .593.231 1.151.652 1.571.42.42.978.65 1.572.65h.001l2.433-.003a.5.5 0 0 0 0-1z",
    fill: "#1080FF",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.514 4.215a.492.492 0 0 1-.5-.486v-.02a.5.5 0 0 1 .5-.5c.28 0 .5.22.5.5 0 .273-.22.506-.5.506zm0 2.28c.54 0 2.087-1.413 2.087-2.773a2.086 2.086 0 0 0-2.087-2.087 2.086 2.086 0 0 0-2.086 2.087c0 1.36 1.546 2.773 2.086 2.773zM11.487 12.03a.494.494 0 0 1-.5-.494v-.02c0-.273.227-.5.5-.5s.5.227.5.5a.515.515 0 0 1-.5.514zm0-2.587c-1.147 0-2.087.94-2.087 2.087 0 1.366 1.554 2.773 2.087 2.773.54 0 2.087-1.407 2.087-2.774a2.09 2.09 0 0 0-2.087-2.086z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteOptimize);
export default __webpack_public_path__ + "static/media/route_optimize.4b6651dde4fd2450070d46210e2a2095.svg";
export { ForwardRef as ReactComponent };